/* Presentation counter adapted from GoPure; simulated, not Shopify analytics. */
(() => {
  if (customElements.get('softhour-cart-people')) return;

  let people = 24;
  let timer;
  const active = new Set();
  const nextDelay = () => 5000 + Math.floor(Math.random() * 7001);

  function schedule() {
    if (timer !== undefined || active.size === 0) return;
    timer = setTimeout(() => {
      timer = undefined;
      people = Math.max(12, Math.min(38, people + (Math.random() < 0.5 ? -1 : 1)));
      active.forEach(element => element.render());
      schedule();
    }, nextDelay());
  }

  class SofthourCartPeople extends HTMLElement {
    static get observedAttributes() { return ['hidden']; }
    connectedCallback() { this.sync(); }
    disconnectedCallback() { this.stop(); }
    attributeChangedCallback() { this.sync(); }
    sync() {
      if (!this.isConnected || this.hidden) { this.stop(); return; }
      active.add(this);
      this.render();
      schedule();
    }
    stop() {
      active.delete(this);
      if (active.size === 0) {
        clearTimeout(timer);
        timer = undefined;
      }
    }
    render() {
      const counter = this.querySelector('[data-cart-people]');
      if (counter && counter.textContent !== String(people)) counter.textContent = String(people);
    }
  }
  customElements.define('softhour-cart-people', SofthourCartPeople);
})();
